import { sortByKey } from '@semios/app-platform-common'
import { MultiSelect } from 'components/MultiSelect/MultiSelect'
import type { TOptions } from 'components/MultiSelect/MultiSelect.types'
import { translate } from 'i18n/i18n'
import _ from 'lodash'
import React, { useMemo } from 'react'

type IssueTypeMultiSelectProps = {
  issueTypes: Record<number, string>
  selectedIds: number[]
  onChange: (selectedIds: number[]) => void
}

export const IssueTypeMultiSelect: React.FC<IssueTypeMultiSelectProps> = ({
  issueTypes,
  selectedIds,
  onChange,
}) => {
  const issueTypeOptions = useMemo(() => {
    return _.sortBy(
      Object.entries(issueTypes)
        .map(([value, label]) => ({ label, value: +value }))
        .sort(sortByKey('label')),
      'label',
    )
  }, [issueTypes])

  const selectedOptions = useMemo(
    () => selectedIds.map((value) => ({ value, label: issueTypes[value] })),
    [selectedIds, issueTypes],
  )

  const handleSelectionChange = (selectedOptions: TOptions[]) => {
    const statuses = selectedOptions.map((option) => option.value) as number[]

    onChange(statuses)
  }

  return (
    <MultiSelect
      data={issueTypeOptions}
      disabled={issueTypeOptions.length === 0}
      onChange={handleSelectionChange}
      placeholder={translate.phrases.placeholder('Filter by issue types')}
      selectedData={selectedOptions}
    />
  )
}
